// extracted by mini-css-extract-plugin
export default {"gameNameInput":"PartnerNewGameAdd_gameNameInput__nKrrA","addButton":"PartnerNewGameAdd_addButton__g8wl2"};